import React, { Fragment } from "react";
import PropTypes from "prop-types";
import modules from "./header.module.scss";

const Header = (props = {}) => {
  const { label, timestamp, srOnly } = props;

  return (
    <Fragment>
      {label}
      {timestamp && <span className={modules.timestamp}>{` (${timestamp})`}</span>}
      {srOnly && <span className="sr-only">{srOnly}</span>}
    </Fragment>
  );
};

Header.propTypes = {
  label: PropTypes.string.isRequired,
  timestamp: PropTypes.string,
  srOnly: PropTypes.string,
};

export default Header;
